import {
  InvoicePaymentStatusEnum,
  ProjectStatusEnum,
  SaleStatusEnum,
  TourStatusEnum,
} from 'common/constants/enum';
import { PillStatus } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

interface Props {
  value: string;
  style?: StyleObject | any;
}

export default function SalePillStatus(props: Props) {
  const { t } = useTranslation();
  const { value, style } = props;
  let status: 'blue' | 'brown' | 'green' | 'red' | 'yellow' | 'other';
  let text: string = '-';

  switch (value) {
    case SaleStatusEnum.Active:
    case SaleStatusEnum.Rescheduled:
      status = 'green';
      text = t(`status:${value}`);
      break;
    case SaleStatusEnum.OpenTicket:
    case SaleStatusEnum.PendingApproval:
    case SaleStatusEnum.PendingRescheduleApproval:
    case SaleStatusEnum.PendingVoidApproval:
    case SaleStatusEnum.VoidDraft:
    case SaleStatusEnum.RescheduleDraft:
    case ProjectStatusEnum.CancelDraft:
    case ProjectStatusEnum.PendingCancelApproval:
    case SaleStatusEnum.Draft:
    case SaleStatusEnum.Rescheduling:
    case SaleStatusEnum.RevertVoidDraft:
    case SaleStatusEnum.PendingRevertVoidApproval:
    case InvoicePaymentStatusEnum.Pending:
      status = 'yellow';
      if (value === SaleStatusEnum.Draft) {
        text = t('status:draft');
      } else if (value === SaleStatusEnum.Rescheduling) {
        text = t('status:reschedule');
      } else if (value === SaleStatusEnum.PendingApproval) {
        text = t('status:waiting_approval');
      } else if (value === SaleStatusEnum.PendingRescheduleApproval) {
        text = t('status:pending_reschedule');
      } else if (value === SaleStatusEnum.PendingVoidApproval) {
        text = t('status:pending_void');
      } else if (value === InvoicePaymentStatusEnum.Pending) {
        text = t('status:pending');
      } else {
        text = t(`status:${value}`);
      }
      break;

    case SaleStatusEnum.RejectedApproval:
    case SaleStatusEnum.RejectedRescheduleApproval:
      status = 'red';
      if (value === SaleStatusEnum.RejectedApproval) {
        text = t('status:rejected');
      } else if (value === SaleStatusEnum.RejectedRescheduleApproval) {
        text = t('status:rejected_reschedule');
      }
      break;
    case ProjectStatusEnum.Canceled:
    case SaleStatusEnum.Refund:
      status = 'brown';
      if (value === ProjectStatusEnum.Canceled) text = t('status:canceled');
      if (value === SaleStatusEnum.Refund) text = t('status:refund');
      break;
    case SaleStatusEnum.Void:
      status = 'brown';
      text = t('status:void');
      break;
    case SaleStatusEnum.Completed:
    case TourStatusEnum.Closed:
    case SaleStatusEnum.Waiting:
    case InvoicePaymentStatusEnum.Finished:
    default:
      if (value === TourStatusEnum.Closed) text = t('status:closed');
      if (value === SaleStatusEnum.Completed) text = t('status:completed');
      if (value === SaleStatusEnum.Waiting) text = t('status:waiting');
      if (value === InvoicePaymentStatusEnum.Finished)
        text = t('status:finished');
      if (value === SaleStatusEnum.Archived) text = t('status:archived');

      status = 'other';
      break;
  }
  return <PillStatus $style={style} status={status} children={text} />;
}
